import { useEffect } from "react";
import notfoundGif from '../../assets/images/notfound.webp'
import './not-found.css'
const NotFound = () => {
    useEffect(() => {
        document.title = "404 | Casaantonio e piccolo gió";
    }, []);
    return (
        <main className="not-found">
            <img
                src={notfoundGif}
                alt=""
                aria-hidden="true"
            />
            <h2>Diese Seite ist nicht verfügbar</h2>
            <p>Entschuldigung, wir konnten die gesuchte Seite nicht finden.
            </p>
        </main>
    )
}

export default NotFound;